import { GridType } from "../../../../Entities/GridType";
import { CompareScenarios } from "./CompareScenarios";

export const CompareRequestView = () => {
	return <CompareScenarios gridType={GridType.Request} />
}